import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Event as NavigationEvent, Router } from '@angular/router';
import { EventService } from '../service/event.service';
import { SkipToMainContentEvent, SkipToTopContentEvent } from "../service/events";
import { AuthService } from '../service/auth.service';
import { VendorService } from '../service/vendor.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent implements OnInit, AfterViewInit {

  currentRouterUrl: string;
  eventBus: EventService;
  actionSection: boolean = false;

  @ViewChild("topElement") topElement: ElementRef;

  constructor(private authService: AuthService, private _router: Router, eventBus: EventService, private vendorService: VendorService) {
    this.eventBus = eventBus;
  }

  ngOnInit() {
    this._router.events.subscribe(
      (event: NavigationEvent): void => {
        this.currentRouterUrl = this._router.url;
        if (this.authService.getNavLinks() != null) {
          this.actionSection = this.authService.getNavLinks().find(e => e.routerLink === this.currentRouterUrl) != null;
        }
      }
    );
  }

  ngAfterViewInit() {
    this.eventBus.on(
      SkipToTopContentEvent,
      (): void => {
        setTimeout(() => this.topElement.nativeElement.focus());
      }
    );
  }

  onFocusMainContent(event) {
    const classList = event.target.classList;
    const classes = event.target.className;
    if (!classes.includes('showFocus')) {
      classList.add('showFocus');
    }
  }

  onFocusOutMainContent(event) {
    const classList = event.target.classList;
    const classes = event.target.className;
    if (classes.includes('showFocus')) {
      classList.remove('showFocus')
    }
  }

  onClickGoToMainContent(event: any) {
    let vendor: string = sessionStorage.getItem('vendorSkip');
    let index: string = sessionStorage.getItem('index');

    if (vendor) {
      if (index === '1') {
        this.vendorService.emitFocusPage("vendorBatchRequest");
      } else if (index === '2') {
        this.vendorService.emitFocusPage("vendorSearchRequest");
      } else {
        this.vendorService.emitFocusPage("vendorRequestForm");
      }
    } else {
      const classList = event.target.classList;
      const classes = event.target.className;
      this.eventBus.emit(new SkipToMainContentEvent({ text: this.currentRouterUrl }));
      if (classes.includes('showFocus')) {
        classList.remove('showFocus')
      }
    }
  }
}
